var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElSwitch',{staticClass:"app-switch",class:_vm.activeText.length || _vm.inactiveText.length ? 'el-switch--labels' : null,attrs:{"id":_vm.id,"active-text":_vm.activeText,"inactive-text":_vm.inactiveText,"disabled":_vm.disabled,"name":_vm.name},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})
}
var staticRenderFns = []

export { render, staticRenderFns }